export const urbanInfraProjects = [
  {
    id: 1,
    name: "Sai Meadows Phase 1",
    status: "Completed",
    type: "Villa Plots",
    location: "Sarjapur Road, Bengaluru",
    description: "Gated community villa plots in a serene residential area on Sarjapur Road with excellent connectivity and modern infrastructure.",
    area: "30x40 & Odd Sizes",
    units: "60+ Plots",
    highlight: "Peaceful gated community with clear title",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/ae087bfc-ce14-4e14-95f9-b6034e60e155_IMG-20260421-WA0040.jpg?v=d6168ca4571ee4d7f338ca78f236c39a",
    pdfUrl: "https://drive.google.com/file/d/1TwztyGCws7qNPbawLfNL_AJ3HPBKzbL7/view?usp=drivesdk",
  },
  {
    id: 2,
    name: "Sai Meadows Phase 2",
    status: "Completed",
    type: "Villa Plots",
    location: "Sarjapur Road, Bengaluru",
    description: "Premium eco-friendly villa plots on Sarjapur Road with excellent connectivity and peaceful environment. Ideal for families and investors.",
    area: "30x40 & Odd Sizes",
    units: "80+ Plots",
    highlight: "Eco-friendly living with modern amenities",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/baaf4e8a-c47f-41a4-81a1-8e472f54da09_IMG-20260421-WA0038.jpg?v=5574df50463f96d77b235315d867a7f6",
    pdfUrl: "https://drive.google.com/file/d/1czuFMW7mWu2lRQ065EC9X1AxZVaFppX3/view?usp=drivesdk",
  },
  {
    id: 3,
    name: "Sai Meadows Phase 3",
    status: "Completed",
    type: "Villa Plots",
    location: "Sarjapur Road, Bengaluru",
    description: "Gated community villa plots on Sarjapur Main Road. Peaceful residential area with strong connectivity. Ideal for living and investment.",
    area: "30x40 & Odd Sizes",
    units: "100+ Plots",
    highlight: "On Sarjapur Road, Bengaluru",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/eadb86ee-68c8-4d20-810f-adf820c3a635_IMG-20260421-WA0035.jpg?v=8d416b0f6c76ece4feb5e2f08a0edb48",
    pdfUrl: "https://drive.google.com/file/d/1UO2_wx4AQpT4nSPhIOpfDangiMf-h0Hr/view?usp=drivesdk",
  },
  {
    id: 4,
    name: "Anaaya Bliss",
    status: "Completed",
    type: "Villa Plots",
    location: "Sarjapur Road, Bengaluru",
    description: "Premium gated villa plot project on Sarjapur Main Road. Designed for modern lifestyle with peaceful surroundings.",
    area: "30x40 & Odd Sizes",
    units: "70+ Plots",
    highlight: "Premium lifestyle on Sarjapur Road",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/b5edef9e-30cf-4660-832c-aa261788b06f_IMG-20260421-WA0037.jpg?v=2413de3686c76b034a9b5fdb454d0f92",
    pdfUrl: "https://drive.google.com/file/d/1dW39568I4mHAzZ_l9-_28fR0x4x17VrY/view?usp=drivesdk",
  },
  {
    id: 5,
    name: "Urban Meadows",
    status: "Completed",
    type: "Residential Layout",
    location: "Dommasandra, Sarjapur Road",
    description: "Exclusive residential gated layout on Sarjapur Road in Dommasandra area. Designed for peaceful living with modern infrastructure.",
    area: "30x40 & Odd Sizes",
    units: "90+ Plots",
    highlight: "On Sarjapur Road, Dommasandra",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/20528057-1e0d-4ee7-861f-573db102fe87_IMG-20260421-WA0043.jpg?v=d83a6c3851231c43ff92f9d4db02bad6",
    pdfUrl: "https://drive.google.com/file/d/10VYgb2pV9xu46_h4kOOScmtc9WYgmM3T/view?usp=drivesdk",
  },
  {
    id: 6,
    name: "Urban Nest",
    status: "Completed",
    type: "Residential Layout",
    location: "Sarjapur Road, Bengaluru",
    description: "Well-planned residential layout with modern amenities, wide roads, and excellent connectivity to Sarjapur Road IT corridor. Perfect for end-users and investors.",
    area: "30x40 & Odd Sizes",
    units: "75+ Plots",
    highlight: "Well-planned layout with wide roads",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/92391308-6311-4535-ba90-12f0b638afda_IMG-20260421-WA0041.jpg?v=0d6f04ed5994769ccdebc37f85c1e73b",
    pdfUrl: "https://drive.google.com/file/d/1g-6JdqByaiIj86V7L4-kiYZkkhh7Vgd_/view?usp=drivesdk",
  },
  {
    id: 7,
    name: "Green Earth",
    status: "Completed",
    type: "Villa Plots",
    location: "Kodathi Village, Sarjapur Road",
    description: "Affordable villa plots on Sarjapur Road, Kodathi Village. Close to Harvest International School and IT zones. Perfect for nature-friendly living with city connectivity.",
    area: "30x40 & Odd Sizes",
    units: "85+ Plots",
    highlight: "Affordable plots near Harvest International School",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/079b6c3a-a4b7-44f1-97f1-f363455aa3e5_IMG-20260421-WA0039.jpg?v=663ce244df2e1ff43fb8e46465883ad2",
    pdfUrl: "https://drive.google.com/file/d/1KH66VbXyRN9GURqCX_mP1XMMZU_cUEO1/view?usp=drivesdk",
  },
  {
    id: 8,
    name: "Amber Park",
    status: "Ongoing",
    type: "Villa Plots",
    location: "Herabana Village, Laxmeshwar",
    description: "New gated community villa plot project at Herabana Village, Laxmeshwar with premium amenities, wide roads, and excellent investment potential.",
    area: "30x40 & Odd Sizes",
    units: "120+ Plots",
    highlight: "New launch — limited plots available",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/03dd1286-676e-40f1-a282-9015126e8bc7_IMG-20260421-WA0036.jpg?v=734e2d1c4d5b11f4a38070ee00668d25",
    pdfUrl: "https://drive.google.com/file/d/1_ACdgUMiPFiGvTBwa3yRN9Has7aN_a34/view?usp=drivesdk",
  },
  {
    id: 9,
    name: "Urban Palms",
    status: "Ongoing",
    type: "Residential Layout",
    location: "Sarjapur Road, Bengaluru",
    description: "Premium residential layout with palm-lined avenues, modern infrastructure, and excellent connectivity to Bengaluru's IT hubs. Ideal for families seeking peaceful living.",
    area: "30x40 & Odd Sizes",
    units: "95+ Plots",
    highlight: "Palm-lined avenues, premium infrastructure",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/b8d967c3-b9bb-4ca0-a5ee-4fbd6b6be13a_IMG-20260421-WA0042.jpg?v=00d3991808a8aceb60c2dc91ce500d44",
    pdfUrl: "https://drive.google.com/file/d/1jXiu8hslNPEkbnpvs-VlpNtNqDGX_Rul/view?usp=drivesdk",
  },
];

export const urbanInfraAmenities = [
  { icon: "ri-shield-check-line", label: "Gated Community" },
  { icon: "ri-drop-line", label: "Water Connection" },
  { icon: "ri-flashlight-line", label: "Electricity Connection" },
  { icon: "ri-recycle-line", label: "Sewage & Drainage" },
  { icon: "ri-camera-line", label: "CCTV Surveillance" },
  { icon: "ri-user-star-line", label: "24/7 Security" },
  { icon: "ri-lightbulb-line", label: "Street Lights" },
  { icon: "ri-road-map-line", label: "Asphalt Roads" },
  { icon: "ri-building-2-line", label: "6.5 Ft Compound Wall" },
  { icon: "ri-riding-line", label: "Children Play Area" },
  { icon: "ri-plant-line", label: "Park" },
];

export const urbanInfraLocationPoints = [
  { icon: "ri-map-pin-2-line", label: "On Sarjapur Road" },
  { icon: "ri-road-map-line", label: "Sarjapur Main Road Access" },
  { icon: "ri-hospital-line", label: "10 mins from Hospitals" },
  { icon: "ri-graduation-cap-line", label: "5 mins from International Schools" },
  { icon: "ri-bank-line", label: "2 mins to Banks & ATM" },
  { icon: "ri-store-2-line", label: "10 mins to Malls" },
];

export const urbanInfraGalleryImages = [
  {
    id: 1,
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/480a4b49-6a9c-4c98-8588-0d6e4f105164_IMG-20260421-WA0012.jpg?v=02b0ca543e1c7c29ba97821cd3f73b98",
    caption: "Residential Layout",
    category: "Layout",
  },
  {
    id: 2,
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/be49d623-359a-4826-afd3-a4b1ac488f6d_IMG-20260421-WA0011.jpg?v=00d5c2783bef1593a27189a9cf198e1c",
    caption: "Gated Community",
    category: "Community",
  },
  {
    id: 3,
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/de429d81-f5d8-4150-b66a-617742fdd664_IMG-20260421-WA0022.jpg?v=f709d5faca9889278a53561b5ec4f532",
    caption: "Project Site",
    category: "Site",
  },
  {
    id: 4,
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/b3591e3c-26fd-44b7-a7f2-7c113b2bb5f3_IMG-20260421-WA0016.jpg?v=9b56d07c97400179bfa1d297e26c7554",
    caption: "Wide Roads",
    category: "Roads",
  },
  {
    id: 5,
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/a6f7f289-d736-47a7-a889-74a69719c38a_IMG-20260421-WA0018.jpg?v=f0dd89476b1f2755bbf772b5023086f6",
    caption: "Green Open Spaces",
    category: "Green Areas",
  },
  {
    id: 6,
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/2c641743-df69-4f45-934a-5276c66d89aa_IMG-20260421-WA0020.jpg?v=66b24ba626545c9d4017626497280d19",
    caption: "Community Development",
    category: "Community",
  },
  {
    id: 7,
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/fa57f257-af60-4dcd-b9e0-a158a7461584_IMG-20260421-WA0019.jpg?v=20d840bb7fe344734bb9559bfc3263c1",
    caption: "Community Entrance",
    category: "Community",
  },
  {
    id: 8,
    src: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/0120c79f-79b5-43a9-bec6-47e1938af84c_IMG-20260421-WA0017.jpg?v=debaab7703ae5aeff74f2810847aad84",
    caption: "Infrastructure View",
    category: "Roads",
  },
];
